import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {LandingPage} from '../../models/landing-page/landing-page';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../api/api-response';
import {AutocompleteChoice} from '../../components/layout/autocomplete-input/autocomplete-input.component';

@Injectable({
  providedIn: 'root'
})
export class LandingPageService extends AbstractModelService<LandingPage> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/landing-page', LandingPage);
  }

  fetchVariables(): Observable<string[]> {
    return new Observable<string[]>((subscriber) => {
      this.apiClient.get('/landing-page/variables').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData()['variables']);
          subscriber.complete();
        }, error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  decrypt(value: string): Observable<any[]> {
    return new Observable<any[]>((subscriber) => {
      this.apiClient.post('/landing-page/decrypt', {}, {
        value: value
      }).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        }, error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  searchLandingPage(query: string): Observable<AutocompleteChoice[]> {
    return new Observable<AutocompleteChoice[]>(observer => {
      if (query) {
        this.findAll({name: query}).subscribe(response => {
          const choices = response.map(landingPage => {
            return {
              label: landingPage.name ?? '',
              value: landingPage,
            }
          });

          observer.next(choices);
          observer.complete();
        });
      } else {
        observer.next([]);
        observer.complete();
      }
    });
  }

}
